import { filter } from 'rxjs/operators';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { FeatureFlags } from 'src/app/interfaces/enums/feature-flag';
import { HeaderTab } from 'src/app/components/page-nav-bar/page-nav-bar.component';
import { PageNavBarComponent } from 'src/app/components/page-nav-bar/page-nav-bar.component';

@Component({
    selector: 'app-contacts',
    imports: [CommonModule, RouterModule, PageNavBarComponent],
    templateUrl: './contacts.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts.page.css']
})
export class ContactsComponent implements OnInit {
  currentRoute: any = '';

  tabs: HeaderTab[] = [
    { id: 1, text: $localize`:@@firmen:Firmen`, routerLink: 'companies' },
    { id: 2, text: $localize`:@@personen:Personen`, routerLink: 'persons' },
    { id: 3, text: $localize`:@@gesellschaften:Gesellschaften`, routerLink: 'societies', feature: FeatureFlags.Gesellschaften },
  ].filter(tab => !tab.feature || AppGlobals.UserCan(tab.feature));

  constructor(
    private router: Router,
    private appGlobals: AppGlobals
  ) {
    this.updateCurrentRoute(this.router.url);
    this.appGlobals.$headerTitle.next($localize`:@@contacts:Contacts`);
    this.appGlobals.SetGlobalMenuIndex(6);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentRoute(event.urlAfterRedirects);
      });
  }

  private updateCurrentRoute(url: string): void {
    // Without query and fragment: "societies?view=orgchart" is still the societies tab.
    const parts = url.split(/[?#]/)[0].split('/');
    this.currentRoute = parts.length > 3 ? '' : parts;
  }
}
